import { render, staticRenderFns } from "./DRSTExternalLinksFooter.vue?vue&type=template&id=4aa21b64&scoped=true&"
import script from "./DRSTExternalLinksFooter.vue?vue&type=script&lang=ts&"
export * from "./DRSTExternalLinksFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTExternalLinksFooter.vue?vue&type=style&index=0&id=4aa21b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa21b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa21b64')) {
      api.createRecord('4aa21b64', component.options)
    } else {
      api.reload('4aa21b64', component.options)
    }
    module.hot.accept("./DRSTExternalLinksFooter.vue?vue&type=template&id=4aa21b64&scoped=true&", function () {
      api.rerender('4aa21b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTExternalLinksFooter.vue"
export default component.exports